import PropTypes from 'prop-types'
import {
  Table,
  TableBody,
  TableHeader,
  TableHeaderColumn,
  TableRow,
  TableRowColumn,
  TableFooter
} from 'material-ui/Table'

import TableRownColumnUnclickable from 'components/table-row-column-unclickable'
import DeleteIcon from 'images/icn-trash-bin.svg'
import IconButton from 'material-ui/IconButton'
import intl from 'react-intl-universal'
import Pagination from 'components/pagination'

const LabeledFamilyList = ({ data, countData, refreshSearch, handleEdit, handleDelete, qtRegsPerPage, profileAdminOrMasterData, currentPage }) => (
  <Table
    fixedHeader
    fixedFooter
    multiSelectable={false}
    selectable={false}
    wrapperStyle={{ height: '100%' }}
    bodyStyle={{ height: 'calc(100% - 110px)', borderTop: '1px solid rgb(224, 224, 224)', backgroundColor: 'var(--color-contrast-white)' }}
    onCellClick={handleEdit}>
    <TableHeader
      displaySelectAll={false}
      adjustForCheckbox={false}
      style={{ borderBottom: 'none' }}>
      <TableRow style={{ borderBottom: 'none' }}>
        <TableHeaderColumn className='table-header__column'>{intl.get('commons.wallet')}</TableHeaderColumn>
        <TableHeaderColumn className='table-header__column'>{intl.get('commons.family')}</TableHeaderColumn>
        <TableHeaderColumn>{intl.get('commons.labeledFamily')}</TableHeaderColumn>
        <TableHeaderColumn />
      </TableRow>
    </TableHeader>
    <TableBody
      displayRowCheckbox={false}
      showRowHover
    >
      {data.map((v) => (
        <TableRow key={v.Id} style={{ cursor: 'pointer' }}>
          <TableRowColumn>
            {v.MaterialGroup}
          </TableRowColumn>
          <TableRowColumn>
            {v.Family}
          </TableRowColumn>
          <TableRowColumn>
            {v.Description}
          </TableRowColumn>
          <TableRownColumnUnclickable style={{ positon: 'relative', textAlign: 'right' }}>
            {profileAdminOrMasterData &&
              <div title={intl.get('master-data.walletsAndFamilys.labeledFamily.deleteModal.title')}>
                <IconButton onClick={() => handleDelete(v.Id)} >
                  <img alt='delete-icon' src={DeleteIcon} />
                </IconButton>
              </div>
            }
          </TableRownColumnUnclickable>
        </TableRow>
      ))}
    </TableBody>
    <TableFooter>
      <Pagination
        refreshSearch={refreshSearch}
        page={currentPage}
        pageSize={qtRegsPerPage}
        amount={countData}
      />
    </TableFooter>
  </Table>
)

LabeledFamilyList.propTypes = {
  countData: PropTypes.number.isRequired,
  refreshSearch: PropTypes.func.isRequired,
  handleEdit: PropTypes.func.isRequired,
  handleDelete: PropTypes.func.isRequired,
  qtRegsPerPage: PropTypes.number.isRequired,
  profileAdminOrMasterData: PropTypes.func.isRequired,
  data: PropTypes.arrayOf(PropTypes.shape({
    Description: PropTypes.string,
    Family: PropTypes.string
  })).isRequired,
  currentPage: PropTypes.number.isRequired
}

export default LabeledFamilyList
